import { Button } from '../../../../core/components/atoms/Button';
import { Typography } from '../../../../core/components/molecules/Typography';
import { Modal } from '../../../../core/components/templates/Modal';

interface AdminDropRegularCourseModalProps {
  isOpen: boolean;
  onClose: () => void;
  onDrop: (reasons?: string[]) => void;
  userMatriculatedCourse?: any;
}

function AdminDropRegularCourseModal({
  isOpen,
  onClose,
  onDrop,
  userMatriculatedCourse,
}: AdminDropRegularCourseModalProps) {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      position='center'
      className='w-[35%] p-0'
    >
      <div className='flex flex-col gap-lg'>
        <Typography>
          Tem certeza que deseja abandonar o curso{' '}
          {userMatriculatedCourse ? userMatriculatedCourse.title : ''}?
        </Typography>
        <Typography>Essa ação não poderá ser desfeita.</Typography>
        <div className='flex flex-row items-center justify-end gap-sm'>
          <Button variant='text' onClick={onClose}>
            Voltar
          </Button>
          <Button
            variant='text'
            onClick={() => onDrop()}
            className='text-feedback-color-error-pure'
          >
            Abandonar curso
          </Button>
        </div>
      </div>
    </Modal>
  );
}

export { AdminDropRegularCourseModal };
